// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

import React from 'react';
//import ReactDOM from "react-dom";
import IframeResizer from 'iframe-resizer-react';
import urlProps from "../resources/properties";
import './App.css';
import * as microsoftTeams from "@microsoft/teams-js";

/**
 * The 'PersonalTab' component renders the main tab content
 * of your app.
 */
class Tab extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      context: {}
    }
  }

  //React lifecycle method that gets called once a component has finished mounting
  //Learn more: https://reactjs.org/docs/react-component.html#componentdidmount
  componentDidMount(){
    // Get the user context from Teams and set it in the state
    microsoftTeams.getContext((context, error) => {
      this.setState({
        context: context
      });
    });
    // Next steps: Error handling using the error object
  }

  render() {
    return (
        <IframeResizer         
            style={{minWidth: "100%", minHeight: window.innerHeight-10}}
            src={urlProps.properties.enmLink.getUrl()}
            scrolling="no" 
            frameBorder="0"
            heightCalculationMethod="lowestElement"
            title="Enterprise News Manager"
            autoResize="true"
        />
    );
}
}
export default Tab;